import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const Preloader = ({ setLoading }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCount((prev) => {
        if (prev === 100) {
          clearInterval(timer);
          setTimeout(() => setLoading(false), 800);
          return 100;
        }
        return prev + 1;
      });
    }, 20);
    return () => clearInterval(timer);
  }, [setLoading]);

  return (
    <motion.div
      className="fixed inset-0 z-[99999] flex items-center justify-center bg-black text-white"
      exit={{ y: "-100%", transition: { duration: 0.8, ease: [0.76, 0, 0.24, 1] } }}
    >
      <div className="flex flex-col items-center">
        <motion.h1
          className="text-6xl md:text-9xl font-display font-bold"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          {count}%
        </motion.h1>
        <motion.div
          className="w-64 h-1 bg-gray-800 mt-8 rounded-full overflow-hidden"
        >
          <motion.div
            className="h-full bg-accent"
            style={{ width: `${count}%` }}
          />
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Preloader;
